import FormSteps from '@/components/FormSteps';

const Complete = () => (
  <div className="signup-form-container">
    <div className="signup-form-wrapper">
      <FormSteps stepIndex={6} totalSteps={6} />
      <h1 style={{ textAlign: 'center', margin: '0 0 40px' }}>You&apos;re All Set!</h1>
      <p style={{ textAlign: 'center', fontSize: '20px' }}>A representative will contact you shortly to complete setting up your account.</p>
    </div>
  </div>
);

export default Complete;
